interface IData_Pubsub_Entity {
  app: string,
  project: string,
  type: string,
  id: string,
}

/*

  utils

*/
export const getLastChannelChunk = (channel: string) => {
  const chunks = channel.split('.')
  return chunks[chunks.length-1]
}


/*

  entity wrapper

*/
export const getEntityChannel = (entity: IData_Pubsub_Entity): string => {
  return [
    entity.app,
    entity.project,
    entity.type,
    entity.id,
  ].join('.')
}

export const parseChannelEntity = (channel: string): IData_Pubsub_Entity => {
  const [
    app,
    project,
    type,
    id,
  ] = channel.split('.')
  return {
    app,
    project,
    type,
    id,
  }
}

export const EntityFactory = (
  app: string,
  type: string,
) => {
  const get = (project: string, id: string): string => {
    return getEntityChannel({
      app,
      project,
      type,
      id,
    })
  }

  const match = (channel: string) => {
    const entity = parseChannelEntity(channel)
    return entity.app == app && entity.type == type
  }

  const wildcard = (project: string): string => {
    return getEntityChannel({
      app,
      project,
      type,
      id: '*',
    })
  }

  return {
    get,
    match,
    wildcard,
  }
}

/*

  entities

*/

export const supportThreadChannel = EntityFactory('support', 'thread')
export const crmImportChannel = EntityFactory('crm', 'import')
export const astonishTemplateChannel = EntityFactory('astonish', 'template')
export const astonishCampaignChannel = EntityFactory('astonish', 'campaign')
export const knowledgebaseArticleChannel = EntityFactory('knowledgebase', 'article')
export const nopressPublishChannel = EntityFactory('nopress', 'publish')
export const globalNopressPublishChannel = 'global.nopress.publish'
export const marketingPostChannel = EntityFactory('marketing', 'post')

/*

  job

*/
export const getJobChannel = (id: string) => `job.${id}`
export const isJobChannel = (channel: string) => channel.indexOf('job.') == 0
export const getJobId = (channel: string) => getLastChannelChunk(channel)

